import { cn } from '@/utils/shared/Utils';
import { ReactNode } from 'react';

interface SaleSectionProps {
  children: ReactNode;
  label?: string;
  className?: string;
  bodyClassName?: string;
}

export default function SaleSection({ label, children, className, bodyClassName }: SaleSectionProps) {
  return (
    <div
      className={cn(
        'flex flex-col bg-white dark:bg-gray-800 shadow-sm rounded-xl col-span-6 md:col-span-3 xl:col-span-2',
        className,
      )}
    >
      {Boolean(label) && (
        <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60 flex items-center">
          <h2 className="font-semibold text-gray-800 dark:text-gray-100">{label}</h2>
        </header>
      )}
      <div className={cn('px-5 py-4 space-y-2', bodyClassName)}>{children}</div>
    </div>
  );
}
